import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import { getStoredViewState, setViewState, getDefaultViewForPage } from '../../../utils/viewStateUtils';
import LeadList from './leadList';
import LeadGrid from './leadGrid';
import { LeadService } from './lead.service';

type ViewType = 'list' | 'kanban';

const LeadsContainer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getCurrentViewFromUrl = (): ViewType => {
    if (location.pathname.includes('/leads/list')) return 'list';
    if (location.pathname.includes('/leads/grid') || location.pathname.includes('/leads-kanban')) return 'kanban';
    return 'kanban';
  };

  const [currentView, setCurrentView] = useState<ViewType>(() => {
    const storedView = getStoredViewState('leads');
    if (storedView === 'list' || storedView === 'kanban') {
      return storedView as ViewType;
    }
    return getDefaultViewForPage('leads') as ViewType;
  });

  useEffect(() => {
    LeadService.evaluateEmailEngagement();
  }, []);

  useEffect(() => {
    if (location.pathname === '/leads') {
      const storedView = getStoredViewState('leads');
      const viewToUse = (storedView || getDefaultViewForPage('leads')) as ViewType;
      const targetRoute = viewToUse === 'list' ? all_routes.leadsList : all_routes.leadsGrid;
      navigate(targetRoute, { replace: true });
      return;
    }

    const storedView = getStoredViewState('leads');
    if (storedView && (storedView === 'list' || storedView === 'kanban')) {
      const targetRoute = storedView === 'list' ? all_routes.leadsList : all_routes.leadsGrid;
      if (location.pathname !== targetRoute) {
        navigate(targetRoute, { replace: true });
      }
      setCurrentView(storedView as ViewType);
    } else {
      const defaultView = getDefaultViewForPage('leads') as ViewType;
      const targetRoute = defaultView === 'list' ? all_routes.leadsList : all_routes.leadsGrid;
      if (location.pathname !== targetRoute) {
        navigate(targetRoute, { replace: true });
      }
      setCurrentView(defaultView);
      setViewState('leads', defaultView);
    }
  }, [location.pathname, navigate]);

  const handleViewSwitch = (view: ViewType) => {
    setViewState('leads', view);
    setCurrentView(view);
    
    const targetRoute = view === 'list' ? all_routes.leadsList : all_routes.leadsGrid;
    navigate(targetRoute, { replace: true });
  };

  return (
    <>
      {currentView === 'list' ? (
        <LeadList onViewSwitch={handleViewSwitch} />
      ) : (
        <LeadGrid onViewSwitch={handleViewSwitch} />
      )}
    </>
  );
};

export default LeadsContainer;
